const pagesIdpEn = {
  settings: {
    authenticationMethod: {
      description: 'Configure login requirements for each account type.',
      title: 'Login requirements'
    },
    navigation: {
      authenticationMethod: 'Login requirements',
      label: 'Settings',
      password: 'Password',
      session: 'Session rules',
      sso: 'SSO'
    },
    sso: {
      description: 'Provides SSO to external SaaS (DRESS CODE = IdP).',
      title: 'SSO — Connected SaaS'
    }
  },
  tabs: {
    accessRules: 'Access rules',
    alerts: 'Alerts',
    authPolicies: 'Authentication policies',
    operationActivity: 'Operation activity',
    overview: 'Overview',
    settings: 'Settings'
  },
  title: 'Policy Design'
};
export default pagesIdpEn;